module.exports = __webpack_public_path__ + "static/media/SourceSansPro-Regular.47dbe582.ttf";